import classNames from 'classnames';

export default function ExpandButton(props) {

    const buttonClassName = classNames({
        ['sb-expand-on-mobile']: true,
        ['text-center']: true,
        ['active']: !props.blockExpanded,
    })

    return <button onClick={() => props.setBlockExpanded(true)} className={buttonClassName}>
        <span className="fas fa-fw fa-arrow-down" aria-hidden="true"/>
        <span>Expand</span>
        <span className="fas fa-fw fa-arrow-down" aria-hidden="true"/>
    </button>
}
